import CouponsV2List from './CouponsV2List'

export default CouponsV2List
